import $ from 'jquery';
/*
 * Add class plugin
 */
$.fn.clickClass = function (opt) {
  const options = jQuery.extend({
    classAdd: 'add-class',
    addToParent: false,
    event: 'click',
  }, opt);

  return this.each(function () {
    let classItem = jQuery(this);
    if (options.addToParent) {
      if (typeof options.addToParent === 'boolean') {
        classItem = classItem.parent();
      } else {
        classItem = classItem.parents(`.${options.addToParent}`);
      }
    }
    jQuery(this).bind(options.event, (e) => {
      classItem.toggleClass(options.classAdd);
      e.preventDefault();
    });
  });
};
